import { useCallback } from 'react';
import { useHistory } from 'react-router';

import DisplayError from '../../../components/info/DisplayError';
import { PathsLayouts } from '../../../config/routes';
import { useStudentRemovalRequestTranslation } from '../hooks/translation';

export function StudentRemovalRequestViewNotFound() {
  const { t } = useStudentRemovalRequestTranslation();
  const history = useHistory();

  const retry = useCallback(() => {
    history.push(PathsLayouts.studentsRemovalRequest);
  }, [history]);

  return (
    <DisplayError
      insideCard
      textBody={t('detail.notFound.body')}
      retryAction={retry}
    />
  );
}
